import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/** Redirects to the `to` (or fallback `from`) route from the query string. */
export const ReNavigatePage = () => {
  const params = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const from = params.get('from');
  const to = params.get('to');
  useEffect(() => {
    if (to) navigate(to, { replace: true });
    else if (from) navigate(from, { replace: true });
    else console.log('Cannot re-navigate', from, to);
  }, []);
  return <div></div>;
};